import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import {CuentaContabilidad} from '../../../models/cuenta-contabilidad'


@Component({
    selector: 'my-cuenta-Add',
    templateUrl: 'cuentasAddEdit.componen.html',
    providers: [generalService]
})
export class CuentaAddComponent implements OnInit{
    public cuentaContabilidadform: FormGroup;
    private cuentaContabilidad: CuentaContabilidad = new CuentaContabilidad();
    numeroCuenta: string;
    public nivel = 0;
    public nivelGuardadoDB = 0;
    public numeroMaximo = 0;
    public nivelMaximo = 0;
    private ACCOUNT_ID = undefined;
    private PARENT_ACCOUNT_ID = undefined;
    private DIRECT_PARENT_ACCOUNT_ID = undefined;
    public bloquearBtnGuardar = false;
    
    public  rangoRequerido = false
    listNaturaleza =[
        {DEBTOR: 0, NAME: 'Acreedora'},
        {DEBTOR: 1, NAME: 'Deudora'}
    ]
    public listCodigoSAT: any[] = [];
    public listRange: any[] = [];
    public listCont: any[] = [];
    public Cont: any[] = [];
    public title = "";
    public title2 = "";
    public titleBtn = "";
    public texmensaje = "";
    public rangoValue = 0;
    public actualizar = false;
    public mismoNivel = false;
    public mismaCuenta = false;
    public codigoSat = true;
    public cuentaPadre = false;
    public list_Cuentas: any[] = [];
    timeout: any;
    public listCodigoSAT_Aux: any[] = [];
    AfectableOptions = [
        { value: 1, label: 'Sí' },
        { value: 0, label: 'No' }
      ];
    
    constructor(private router: Router,public dataService: DataService,
        private formBuilder: FormBuilder, private _generalService: generalService,
        private route: ActivatedRoute,) {
        this.cuentaContabilidadform = new FormGroup({});
    }
  
    ngOnInit() {
        //saber el valor maximo 
        this.numeroMaximo = this.dataService.dialogRef._containerInstance._config.data.levemax;
        this.nivelMaximo = ((this.numeroMaximo * 4) + (this.numeroMaximo - 1)) ;
        this.ACCOUNT_ID = this.dataService.dialogRef._containerInstance._config.data.ACCOUNT_ID;
        
        //this.list_Cuentas =  this.dataService.dialogRef._containerInstance._config.data.list_Cuentas;

        this.buildForm( this.numeroMaximo);
        this.getAddEdit();
       // this.dateFormat();
        this.validateRoute();
    }
    cerrarModal() {
        this.dataService.dialogRef.close();
    }

    
    buildForm(valorMaximo: number) {   
        // Construye el patrón de expresión regular dinámicamente
        const pattern = new RegExp(`^(\\d{4}\\s?\\-\\s?){0,${valorMaximo - 1}}\\d{4}$`); 
        this.cuentaContabilidadform = this.formBuilder.group({
            numeroCuentaControl: ['', [
                Validators.required,
                Validators.pattern(pattern), // Usamos el patrón dinámico aquí
                Validators.minLength(this.nivelMaximo), 
                Validators.maxLength(this.nivelMaximo) 
            ]],
            nombreControl :['', [Validators.required, Validators.maxLength(99)]],
            nivelControl: [{ value: null, disabled: true }, [Validators.maxLength(10)]],
            naturalezaControl: [{ value: null, disabled: true }, [ Validators.required,Validators.maxLength(50)]],
            codigaSatControl: [null, [Validators.maxLength(50)]],
            rangoControl: [{ value: null, disabled: true }, [
                Validators.required,
                Validators.maxLength(50)
            ]],
            cuentaMayorControl: [{ value: null, disabled: true }, [Validators.maxLength(50)]],
            afectableControl: [{ value: null}],
            altaControl: [{ value: null, disabled: true }, [Validators.maxLength(50)]],
            fechaAltaControl: [{ value: null, disabled: true }, [Validators.maxLength(50)]],
            ultimaModificacionControl: [{ value: null, disabled: true }, [Validators.maxLength(50)]],
            fechaModificacionControl: [{ value: null, disabled: true }, [Validators.maxLength(50)]],
        });
    
        // Añadir listener para aplicar formato y guardar el valor cuando el input pierde el foco
        const numeroCuentaControl = this.cuentaContabilidadform.get('numeroCuentaControl');
        if (numeroCuentaControl) {
            numeroCuentaControl.valueChanges.subscribe(value => {
                if (value) {
                    const formattedValue = this.formatNumber(value,valorMaximo);
                    this.cuentaContabilidadform.controls.numeroCuentaControl.setValue(formattedValue, { emitEvent: false });
                    this.numeroCuenta = formattedValue;
                }
            });
    
            numeroCuentaControl.statusChanges.subscribe(status => {
                if (status === 'VALID' && !numeroCuentaControl.pristine) {
                    let metodo = 'Cuenta/accountExists';
                    const params = { 
                        loacs: sessionStorage.getItem('acslo'),
                        NUMBER:this.numeroCuenta
                    };
                    this._generalService.metodoCallParams(params, metodo).subscribe(
                        result => {
                            const tableResult = JSON.parse(result);
                            this.Cont = tableResult.Table;
                            this. calcularValoresCuenta(this.numeroCuenta);
                
                        },
                        error => {  console.log(<any>error);  }
                        );
                   
                }
            });
        }
    }
    formatNumber(input: string, valorMaximo:number): string {
        // Remover todos los caracteres no numéricos
        const numericValue = input.replace(/\D/g, '');
        // Insertar guiones cada 4 dígitos
        const formattedValue = numericValue.replace(/(\d{4})(?=\d)/g, '$1-');
        // Truncar a 16 caracteres contado los 4 guiones 
        
        return formattedValue.substring(0, this.nivelMaximo);
    }

    backward() {
        this.router.navigate(['app/cuentas']);
    }
    
    validateRoute() {
        if (this.ACCOUNT_ID === 0) {
            this.title = 'Agregar';
            this.title2 = 'Guardo';
            this.titleBtn = 'Guardar'
            this.actualizar = false;
            this.texmensaje = '¡La cuenta no se puede crear ya que no tiene cuenta padre!';
           
         
        }else{
            this.title2 = 'Actualizó';
            this.title = 'Actualizar'
            this.titleBtn = 'Actualizar'
            this.actualizar = true;
            this.texmensaje = '¡La cuenta no se puede actualizar ya que su cuenta padre no es la misma! ';
           
        }
      }
    guardarCuenta() {
        this.bloquearBtnGuardar = true;
        this.mapearDatosFormularioEnModelo();
        this.addCuenta();
    }

    mapearDatosFormularioEnModelo() {
        this.cuentaContabilidad.NUMBER = this.cuentaContabilidadform.controls['numeroCuentaControl'].value;
        this.cuentaContabilidad.NAME = this.cuentaContabilidadform.controls['nombreControl'].value;
        this.cuentaContabilidad.NIVEL = this.cuentaContabilidadform.controls['nivelControl'].value;
        let afectablaValue = null;
        if (this.cuentaContabilidadform.controls['afectableControl'].value === 1) {
            afectablaValue = 1;
        } else {
            afectablaValue = 0;
        }
        
        this.cuentaContabilidad.AFFECTABLE  = afectablaValue;
        this.cuentaContabilidad.DEBTOR  = this.cuentaContabilidadform.controls['naturalezaControl'].value;
        this.cuentaContabilidad.CREATION_DATE  = new Date();
        this.cuentaContabilidad.LAST_UPDATE_DATE  = new Date();
        this.cuentaContabilidad.ACCOUNT_SAT_ID  = this.cuentaContabilidadform.controls['codigaSatControl'].value;
        this.cuentaContabilidad.RANGE_ACCOUNT_ID  = this.rangoValue;
        this.cuentaContabilidad.ACCOUNT_ID  = this.dataService.dialogRef._containerInstance._config.data.ACCOUNT_ID;
        this.cuentaContabilidad.PARENT_ACCOUNT_ID =  this.PARENT_ACCOUNT_ID
        this.cuentaContabilidad.DIRECT_PARENT_ACCOUNT_ID =  this.DIRECT_PARENT_ACCOUNT_ID
        

        this.cuentaContabilidad.loacs =  sessionStorage.getItem('acslo');

    }
      
   

    calcularValoresCuenta(numeroCuenta: string) {
        this.mismoNivel =false;
        // Dividir el número de cuenta en grupos separados por el guión
        const grupos = numeroCuenta.split('-');
        let bandera = false;
        // cuenta cuantos grupos hay despues del 0
        for (let i = grupos.length - 1; i >= 0; i--) {
            if (grupos[i].match(/[1-9]/)) {
                break; 
            } else {
                grupos.pop(); 
                bandera = true;
            }
        }
        let numeroTotal = grupos.length - 1;
        if(grupos[numeroTotal]){
            bandera = true;
        }else{
            bandera = false;
        }
        
        // Contar cuántos grupos no son cero
        const gruposNoCero = grupos.filter(grupo => grupo !== '0000');


        if(bandera){
            this.nivel = grupos.length;
        }else{
            this.nivel = gruposNoCero.length;
        }
        

        this.cuentaContabilidadform.controls['nivelControl'].setValue(this.nivel);

               
        //validaciones de campos
        // if (this.nivel === 1) {
        //     this.cuentaContabilidadform.controls['naturalezaControl'].enable();
        //     this.codigoSat = false;
        // } else if (this.nivel === this.numeroMaximo) {
        //     this.cuentaContabilidadform.controls['naturalezaControl'].disable();
        //     this.codigoSat = false;
        // } else {
        //     this.cuentaContabilidadform.controls['naturalezaControl'].disable();
        //     this.codigoSat = true;
        // }

       
        this.numeroCuenta;
        this.listRange;
        let descripcionRango = null;

        for (const item of this.listRange) {
            if (this.numeroCuenta >= item.INITIAL && this.numeroCuenta <= item.END) {
                descripcionRango = item.DESCRIPTION;
                this.rangoValue = item.RANGE_ACCOUNT_ID;
                break;
            }
        }
        this.cuentaContabilidadform.controls['rangoControl'].setValue(descripcionRango); 
        if(descripcionRango !== null){
            this.rangoRequerido = true;
        }else{
            this.rangoRequerido = false;
        }

        let ceuntaMayor ="";
        this.nivel == 1 ? ceuntaMayor = "Si" : ceuntaMayor = "No";
        this.cuentaContabilidadform.controls['cuentaMayorControl'].setValue(ceuntaMayor); 

        let afectable ="";
        this.nivel == this.numeroMaximo? afectable = "Si" : afectable = "No";// saber si el nivel es igual al nivel maxi que traigo de db
        //this.cuentaContabilidadform.controls['afectableControl'].setValue(afectable);
        this.cuentaContabilidadform.controls['afectableControl'].setValue(afectable === "Si" ? 1 : 0);



        //******************** */
       

        // validamos si es hijo y seteamos la naturaleza
        
        //const cuenta = this.Cont.find(cuenta => this.compararPrimerosCuatroDigitos(cuenta['NUMBER'], numeroCuenta));
        var cuenta = this.Cont.find(cuenta => this.compararPrimerosGrupos(cuenta['NUMBER'], numeroCuenta, (this.nivel - 1)));

        if( cuenta && cuenta['NIVEL'] !== (this.nivel - 1)){
            cuenta = undefined
        }

        
        //let cuenta:any = this.Cont;
        if (cuenta && cuenta.ACCOUNT_STATUS_ID == 1) {
            this.cuentaContabilidadform.controls['naturalezaControl'].setValue(cuenta.DEBTOR_ID);

            if(this.nivel == 2){
                this.PARENT_ACCOUNT_ID = cuenta.ACCOUNT_ID;
                this.DIRECT_PARENT_ACCOUNT_ID = cuenta.ACCOUNT_ID; //padre 
            }else{
                this.PARENT_ACCOUNT_ID = cuenta.PARENT_ACCOUNT_ID;
                this.DIRECT_PARENT_ACCOUNT_ID = cuenta.ACCOUNT_ID; //padre 
            }
           
            
            this.cuentaPadre = false;

        } else {
            //validacion para que no se crea una cuenta si cuenta padre
            if(this.nivel != 1){
                this._generalService.toastCall(this.texmensaje);
                this.cuentaPadre = true;
            }else{
                this.cuentaPadre = false;
            }
            // this._generalService.toastCall(this.texmensaje);
            // this.cuentaPadre = true;
            
        }

        // validar si existe otra cuenta con ese mismo numero
        const cuentaExt = this.Cont.find((element) => element.NUMBER === numeroCuenta);
        if(cuentaExt && cuentaExt.NUMBER === numeroCuenta && this.ACCOUNT_ID != cuentaExt['ACCOUNT_ID'] ){
            this.mismaCuenta = true;
            this._generalService.toastCall('¡Ya existe otra cuenta con ese número!');
        }else {
            this.mismaCuenta = false; 
        }

        //validar que en la actualizacion no se cambie de nivel
        if(this.actualizar){
            if(this.nivel != this.nivelGuardadoDB){
                this._generalService.toastCall('¡Tienes que conservar el mismo nivel!');
                this.mismoNivel =true;
            }
        }

       

         
    }  
    // compararPrimerosCuatroDigitos(numero1, numero2) {
    //     return numero1.substring(0, 4) === numero2.substring(0, 4);
    // }
    compararPrimerosGrupos(numero1, numero2, nivel) {
        const grupos1 = numero1.split('-').slice(0, nivel);
        const grupos2 = numero2.split('-').slice(0, nivel);
        return JSON.stringify(grupos1) === JSON.stringify(grupos2);
    }

    
    
    addCuenta(){
        let bandera = 0;

        this._generalService.metodoCallParams(this.cuentaContabilidad, 'Cuenta/addCuenta').subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                bandera = tableResult.Table[0]['@bandera'];

                setTimeout(() => {
                    if(bandera == 1){
                        this._generalService.toastCall('¡Registro '+this.title2+' exitosamente!');
                    }else{
                        this._generalService.toastCall('¡El registro no se puede actualizar ya que tiene conservar la misma Naturaleza!');
                    }
                    this.dataService.dialogRef.close(1)
                }, 500); 
    
                
                
            }, (error) => {
              console.log(error as any);
        });
    }
   getAddEdit(){
        let metodo = 'Cuenta/getAddEditCuenta';
        const params = { 
            loacs: sessionStorage.getItem('acslo'),
            ACCOUNT_ID: this.ACCOUNT_ID
        };

        this._generalService.metodoCallParams(params, metodo).subscribe(
        result => {
            const tableResult = JSON.parse(result);
            this.listCodigoSAT = tableResult.Table;
            this.listCodigoSAT_Aux =  this.listCodigoSAT;
            this.listRange = tableResult.Table1;
           
            this.listCont = tableResult.Table2;
            let NumeroHijos = 0;
            NumeroHijos = tableResult.Table3[0]['numero_de_registros'];
            

            if(this.listCont.length > 0){
                this.cuentaContabilidadform.controls['numeroCuentaControl'].setValue(this.listCont[0].NUMBER);
                this.cuentaContabilidadform.controls['numeroCuentaControl'].updateValueAndValidity();// desactiva la validacion ya que si traigo datos
                this.cuentaContabilidadform.controls['nombreControl'].setValue(this.listCont[0].NAME);
                this.cuentaContabilidadform.controls['naturalezaControl'].setValue(this.listCont[0].DEBTOR);
                this.cuentaContabilidadform.controls['codigaSatControl'].setValue(this.listCont[0].ACCOUNT_SAT_ID);
                this.cuentaContabilidadform.controls['nivelControl'].setValue(this.listCont[0].NIVEL);
                this.nivelGuardadoDB = this.listCont[0].NIVEL;
                let ceuntaMayor ="";
                this.listCont[0].NIVEL == 1 ? ceuntaMayor = "Si" : ceuntaMayor = "No";
                this.cuentaContabilidadform.controls['cuentaMayorControl'].setValue(ceuntaMayor);
                let afectable ="";
                this.listCont[0].NIVEL == this.numeroMaximo? afectable = "Si" : afectable = "No";// saber si el nivel es igual al nivel maxi que traigo de db
                //this.cuentaContabilidadform.controls['afectableControl'].setValue(afectable);
                this.cuentaContabilidadform.controls['afectableControl'].setValue(this.listCont[0].AFFECTABLE);
                this.PARENT_ACCOUNT_ID = this.listCont[0].PARENT_ACCOUNT_ID
                this.cuentaContabilidadform.controls['rangoControl'].setValue(this.listCont[0].descripcionRango);
                //this.rangoValue = 0;
                this.rangoValue  = this.listCont[0].RANGE_ACCOUNT_ID //this.rangoValue;
                // Validacion Rango
                if(this.listCont[0].descripcionRango != undefined){
                    this.rangoRequerido = true;
                }
                // Validacion Codigo Sat
                // if (this.listCont[0].NIVEL === 1) {
                //     this.cuentaContabilidadform.controls['naturalezaControl'].enable();
                //     this.codigoSat = false;
                // } else if (this.listCont[0].NIVEL === this.numeroMaximo) {
                //     this.cuentaContabilidadform.controls['naturalezaControl'].disable();
                //     this.codigoSat = false;
                // } 
                
                this.cuentaContabilidadform.controls['altaControl'].setValue(this.listCont[0].CREATION_UserName);
                this.cuentaContabilidadform.controls['ultimaModificacionControl'].setValue(this.listCont[0].UPDATE_UserName);
                this.cuentaContabilidadform.controls['fechaAltaControl'].setValue(this.listCont[0].CREATION_DATE);
                this.cuentaContabilidadform.controls['fechaModificacionControl'].setValue(this.listCont[0].LAST_UPDATE_DATE);
                if(NumeroHijos >= 1){
                    this.cuentaContabilidadform.controls['numeroCuentaControl'].disable();
                    if(this.listCont[0].NIVEL !== 1){
                        this._generalService.toastCall('¡El número de Cuenta no se puede modificar ya que tiene cuentas hijas!');
                    }else{
                        this._generalService.toastCall('¡El número de Cuenta y la Naturaleza no se pueden modificar ya que tiene cuentas hijas!');
                        this.cuentaContabilidadform.controls['naturalezaControl'].disable();
                    }
                    
                   
                }
                
            }
        
        },
        error => {  console.log(<any>error);  }
        );
    }

    
    onKeyUpCodigo(val: any){
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
      
        const searchValue = val.currentTarget.value.trim().toLowerCase();
        this.timeout = setTimeout(() => {
            
      
            let arr: any[];
      
            if (searchValue !== "") {
                arr = this.listCodigoSAT
                .filter((obj) => 
                    obj.NAME.toLowerCase().includes(searchValue.toLowerCase()) || 
                    obj.NUMBER.toString().toLowerCase().includes(searchValue.toLowerCase())
                )
                .slice(0, 100);
            } else {
                arr = this.listCodigoSAT.slice(0, 10); // Restaurar a los primeros 10 elementos del array original
            }
            
            //console.log("filtroCp: Resultado filtrado:", arr);
            this.listCodigoSAT_Aux = arr;
        }, 300); // Esperar 300 ms antes de ejecutar la búsqueda
    }
 
}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/cuentas/cuentasAddEdit/cuentasAddEdit.component.ts